import { styled } from "@mui/material";
import { CheckboxInput } from "components/Input/FormControl";
import CalendarInput from "components/Input/CalendarInput";
import MultipleSelect from "components/Input/MultipleSelect";
import { useFormikContext } from "formik";
import TimeInput from "components/Input/TimeInput";
import { useSelector } from "react-redux";

const LimitationTimeContainer = styled("div")(({ theme }) => ({
  padding: "24px",
}));
const MarignContainer = styled("div")(({ theme }) => ({
  margin: "10px 0",
}));
const LimitationTimeComponentContainer = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, 45%)",
  justifyContent: "space-between",
  width: "100%",
  maxWidth: "450px",
  margin: "25px",
}));

const LimitationDateComponent = () => {
  return (
    <LimitationTimeComponentContainer>
      <CalendarInput name="from" label="از تاریخ" required={true} isGregorian={false} />
      <CalendarInput name="to" label="تا تاریخ" required={true} isGregorian={false} />
    </LimitationTimeComponentContainer>
  );
};
const LimitationTimeComponent = () => {
  return (
    <LimitationTimeComponentContainer>
      <TimeInput name="fromHourMinute" label="از ساعت" />
      <TimeInput name="toHourMinute" label="تا ساعت" />
    </LimitationTimeComponentContainer>
  );
};

const MultipleSelectContainer = styled("div")(({ theme }) => ({
  width: "100%",
  maxWidth: "450px",
  margin: "25px",
}));

const dayOfWeekItems = [
  {
    title: "شنبه",
    value: "saturday",
  },
  {
    title: "یک شنبه",
    value: "sunday",
  },
  {
    title: "دوشنبه",
    value: "monday",
  },
  {
    title: "سه شنبه",
    value: "tuesday",
  },
  {
    title: "چهارشنبه",
    value: "wednesday",
  },
  {
    title: "پنج شنبه",
    value: "thursday",
  },
  {
    title: "جمعه",
    value: "friday",
  },
];

const DayOfWeekComponent = () => {
  return (
    <MultipleSelectContainer>
      <MultipleSelect name="weekdays" option={dayOfWeekItems} />
    </MultipleSelectContainer>
  );
};

const limitationItems = [
  {
    label: "محدودیت ساعت",
    name: "timeLimitation",
    Component: LimitationTimeComponent,
  },
  {
    label: "محدودیت روزهای هفته",
    name: "dayLimitation",
    Component: DayOfWeekComponent,
  },
  {
    label: "محدودیت تاریخ",
    name: "dateLimitation",
    Component: LimitationDateComponent,
  },
];

const LimitationTime = () => {
  const formikContext = useFormikContext();
  const { values } = formikContext;

  //@ts-ignore
  const editItem = useSelector((state) => state).formReducer.editItem;

  return (
    <LimitationTimeContainer>
      {limitationItems.map((item, key) => {
        const { Component } = item;
        return (
          <MarignContainer key={key}>
            <CheckboxInput name={item.name} label={item.label} />
            {/* @ts-ignore */}
            {values[item.name] && <Component />}
          </MarignContainer>
        );
      })}
    </LimitationTimeContainer>
  );
};

export default LimitationTime;
